import React from "react";
import "./Benefitbox.css"; // Or wherever the styles are

const BenefitBox = ({ icon, title, description }) => {
  return (
    <div className="benefit-box">
      <img src={icon} alt="icon" className="benefit-icon" />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default BenefitBox;
